import { render, staticRenderFns } from "./VehicleSidebar.vue?vue&type=template&id=3a9850ee&scoped=true&"
import script from "./VehicleSidebar.vue?vue&type=script&lang=js&"
export * from "./VehicleSidebar.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSidebar.css?vue&type=style&index=0&id=3a9850ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9850ee",
  null
  
)

export default component.exports